<template>
  <div class="spa-compat-bg min-h-[calc(100vh-60px)]">
    <div class="mx-auto w-full max-w-[85rem] px-3 sm:px-4 md:px-6 lg:px-12">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
  .spa-compat-bg {
    background-color: #f8fafc;
  }
</style>
